<template>
    <v-card
        class="mx-auto blob-details"
        outlined
        :color="colors.quadrant[blob.quadrant]"
    >
        <v-toolbar
            flat
            :color="colors.quadrant[blob.quadrant]"
            dark
        >
            <v-toolbar-title>
                {{ radar['quadrant_' + blob.quadrant] }}
            </v-toolbar-title>

            <v-spacer></v-spacer>


            <v-tooltip
                    top
                    :open-delay="tooltipDelay"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="backToRadar"
                    >
                        <v-icon>mdi-radar</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('controls.tooltip.back_radar') }}</span>
            </v-tooltip>

            <v-tooltip
                    top
                    :open-delay="tooltipDelay"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="back"
                    >
                        <v-icon>mdi-format-list-bulleted</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('controls.tooltip.back_quadrant') }}</span>
            </v-tooltip>
        </v-toolbar>
        <v-card flat>
            <v-divider></v-divider>
            <v-toolbar
                    flat
            >
                <v-toolbar-title>
                    <v-icon>mdi-image-filter-tilt-shift</v-icon>
                    {{ blob.name }}
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <BlobFormDialog :blob="blob" v-if="isOwner"></BlobFormDialog>

                <EntryFormDialog :blob-entry="{ sector: blob.sector, sector_progress: blob.sector_progress }" v-if="isOwner"></EntryFormDialog>
            </v-toolbar>
            <v-divider></v-divider>

            <v-list
                    v-if="blob.entries.length > 0"
                    two-line
            >

                <v-list-item>
                    <v-card flat>
                        <v-card-text
                                flat
                                v-html="blob.description.replace(/\n/g, '<br>')"
                        ></v-card-text>
                    </v-card>
                </v-list-item>
                <v-divider></v-divider>

                <template v-for="(entry, i) in blob.entries">
                    <v-hover
                        v-slot:default="{ hover }"
                        :key="i"
                    >
                        <v-list-item
                                :class="hover ? 'active_entry': ''"
                                @mouseenter="addGhostBlob(entry)"
                                @mouseleave="removeGhostBlob()"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-update</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle
                                    class="font-weight-thin"
                                >
                                    {{ entry.created_at|formatDateTime }}
                                </v-list-item-subtitle>
                                <div v-html="entry.text.replace(/\n/g, '<br>')"></div>
                            </v-list-item-content>
                            <v-list-item-avatar>
                                <EntryFormDialog :blob-entry="entry" :btn-color="colors.quadrant[blob.quadrant]" v-if="isOwner"></EntryFormDialog>
                            </v-list-item-avatar>
                        </v-list-item>
                    </v-hover>
                    <v-divider :key="'divider'+i"></v-divider>
                </template>
            </v-list>
            <v-list v-else>
                <v-list-item>
                    {{ $t('entry.list.empty')}}
                </v-list-item>
            </v-list>
        </v-card>
    </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BlobFormDialog from './BlobFormDialog'
  import EntryFormDialog from '../entry/EntryFormDialog'
  import { settings, canvas } from '../../settings/settings.js'

  export default {
    name: 'BlobDetails',
    components: { EntryFormDialog, BlobFormDialog },
    props: {
      blob: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      ...settings,
      ...canvas,
      showInfo: false,
    }),

    computed: {
      ...mapGetters({
        radar: 'radars/getCurrentRadar',
        userId: 'user/userId',
      }),

      isOwner() {
        return this.blob.owner_id === this.userId
      },
    },
    created () {
      this.$store.commit('blobs/clearHighlightBlobId')
    },
    methods: {
      back () {
        this.$store.commit('blobs/clearCurrentBlobId')
        // this.$emit('openQuadrant', this.blob.quadrant)
        this.$router.push({ name: 'radar', params: { quadrantId: this.blob.quadrant } }).catch(() => {})
      },
      backToRadar () {
        this.$store.commit('blobs/clearCurrentBlobId')

        this.$router.push({ name: 'radar', params: { radarId: this.blob.radar_id } }).catch(() => {})
      },

      addGhostBlob (entry) {
        this.$store.commit('blobs/setGhostBlob', { blob_id: this.blob.id, quadrant: this.blob.quadrant, sector: entry.sector, sector_progress: entry.sector_progress })
      },

      removeGhostBlob () {
        this.$store.commit('blobs/clearGhostBlob')
      }
    }
  }
</script>

<style lang="scss">
    .active_entry {
        background-color: #F5F5F5;

        * {
            background-color: transparent !important;
        }
    }
</style>
